'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';
import CheckSuccessIcon from '../../Images/CheckSuccessIcon/index.js';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import Typography from '../../Typography/index.js';
import { LogoWrap, Logo } from '../styled.js';

function XaloLeadInformation(_a) {
    var _b, _c, _d;
    var xaloLead = _a.xaloLead;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Col, { xs: 24 },
            React__default.createElement(Row, { gutter: [4, 0] },
                React__default.createElement(Col, null,
                    React__default.createElement(LogoWrap, null,
                        React__default.createElement(Logo, { src: (_b = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupImage) !== null && _b !== void 0 ? _b : '', alt: 'logo xalo lead' }))),
                React__default.createElement(Col, null,
                    React__default.createElement(Typography, { variant: 'p', color: colors.primary[0], name: 'label', size: 'medium' }, (_c = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupTitle) !== null && _c !== void 0 ? _c : '')))),
        (xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.benefits) && xaloLead.benefits.length > 0 ? (React__default.createElement(Col, { xs: 24 },
            React__default.createElement(Row, { gutter: 8 },
                React__default.createElement(Col, null,
                    React__default.createElement(Typography, { variant: 'p', color: colors.primary[0], name: 'label', size: 'medium' }, (_d = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupPointTitle) !== null && _d !== void 0 ? _d : '')),
                xaloLead.benefits.map(function (item, index) {
                    if (!item)
                        return;
                    return (React__default.createElement(Col, { key: index },
                        React__default.createElement(Row, { gutter: [0, 6], align: 'top' },
                            React__default.createElement(Col, { xs: 'auto', style: { marginTop: 3 } },
                                React__default.createElement(CheckSuccessIcon, null)),
                            React__default.createElement(Col, { xs: 'fill' },
                                React__default.createElement(Typography, { variant: 'p', color: colors.primary[0], name: 'paragraph', size: 'medium' }, item)))));
                })))) : null));
}

export { XaloLeadInformation as default };
//# sourceMappingURL=XaloLeadInformation.js.map
